<div class="general-container">
  <button class="btn btn-primary" (click)="openNew(content)">Neu</button>
</div>
@for (passwordKey of passwordKeys; track passwordKey) {
  <div class="general-container">
    <h3>Passwörter {{passwordKey}}</h3>
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Name</th>
          <th>Geheimnis</th>
          @if (showTme()) {
            <th>Zuletzt geändert</th>
          }
          <th>Aktionen</th>
        </tr>
      </thead>
      <tbody>
        @for (pw of passwords[passwordKey]; track pw) {
          <tr>
            <td class="ws">{{pw.name}}</td>
            <td class="ws">{{pw.secret}}</td>
            @if (showTme()) {
              <td>{{pw.tme | date: 'yyyy-MM-dd HH:mm:ss'}}</td>
            }
            <td><button class="btn btn-secondary" (click)="openEdit(content, pw)">Bearbeiten</button> </td>
          </tr>
        }
      </tbody>
    </table>
    <div></div>
  </div>
}


<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Passwort bearbeiten</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="name">Name</label>
        <textarea id="name" class="form-control" name="name" type="text" [(ngModel)]="currentEntry.name"></textarea>
      </div>
      <div class="form-group">
        <label for="secret">Geheimnis</label>
        <textarea id="secret" class="form-control" name="secret" type="text" [(ngModel)]="currentEntry.secret"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modal.dismiss('Abort click')">Abbrechen</button>
    <button type="button" class="btn btn-success" (click)="modal.close('Save click')">Speichern</button>
  </div>
</ng-template>
